import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";

import Avatar from "@mui/material/Avatar";

import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import api from "services/api";

import qs from "query-string";
import toast from "react-hot-toast";

import colors from "assets/theme/base/colors";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import TabPanel from "components/UpStyled/TabPanel";

import PostStyleModal from "pages/de/posts/components/PostStyleModal";
import PostReorderModal from "pages/de/posts/components/PostReorderModal";
import ImportStylePicturesModal from "pages/de/posts/components/ImportStylePicturesModal";
import ImportMoodboardPicture from "pages/de/posts/components/ImportMoodboardPicture";
import PhotoGrid from "pages/de/posts/components/PhotoGrid";
import EditPhotoGrid from "pages/de/posts/components/EditPhotoGrid";
import SettingModal from "pages/de/posts/components/SettingModal";
import PostDetailModal from "pages/de/posts/detail";
import LeaveConfirmationModal from "pages/de/posts/components/LeaveConfirmationModal";
import EditColumnGrid from "pages/de/posts/components/EditColumnGrid";
import ImageEditorModal from "pages/de/posts/components/ImageEditorModal";
import PostImageWrapper from "pages/de/posts/components/PostImageWrapper";

import ImageIcon from "@mui/icons-material/Image";
import TitleIcon from "@mui/icons-material/Title";
import ViewComfyIcon from "@mui/icons-material/ViewComfy";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CollectionsIcon from "@mui/icons-material/Collections";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import StyleIcon from "@mui/icons-material/Style";
import PaletteIcon from "@mui/icons-material/Palette";
import FitScreenIcon from "@mui/icons-material/FitScreen";
import SettingsIcon from "@mui/icons-material/Settings";
import EditIcon from "@mui/icons-material/Edit";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import VerticalSplitIcon from "@mui/icons-material/VerticalSplit";

import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import FormatAlignCenterIcon from "@mui/icons-material/FormatAlignCenter";
import FormatAlignRightIcon from "@mui/icons-material/FormatAlignRight";

import { nanoid } from "nanoid";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import parse from "html-react-parser";
import moment from "moment";
import Cropper from "react-easy-crop";

import UploadIcon from "@mui/icons-material/Upload";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import Slider from "@mui/material/Slider";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import {
  getBase64,
  dataURLtoFile,
  getBase64ImageFromUrl,
  getStyleImages,
  uploadFileSizeLimit,
} from "utils/imageHelper";
import { getAllPostImages, handleUpdatePostContent } from "utils/helper";
import ListItemIcon from "@mui/material/ListItemIcon";
import { getImageSize } from "react-image-size";
import { Resizable } from "re-resizable";
import ReactPlayer from "react-player";
import Skeleton from "@mui/material/Skeleton";
import NewSharedBar from "pages/de/share-page/newsharebar";
import PostFileList from "pages/de/posts/components/PostFileList";
import FolderIcon from "@mui/icons-material/Folder";
import DesktopWindowsOutlinedIcon from "@mui/icons-material/DesktopWindowsOutlined";

const DEFAULT_MARGIN_X = 60;
const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    //[{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    [{ font: [] }],
    [{ align: [] }],

    ["clean"], // remove formatting button
  ],
};
const ASPECT_RATIO = 300 / 234;
const CROPPED_IMAGE_TYPE = "image/jpeg";
const POST_NAME_MAX_LENGTH = 70;
const POST_DESCRIPTION_MAX_LENGTH = 200;

const initialData = {
  title: "Untitled",
  metadata: {
    settings: {
      backgroundColor: "#ffffff",
      mb: 40,
    },
    content: [],
  },
};

const CreatePostPage = ({ edit = false }) => {
  const [post, setPost] = useState();
  const [postControlAnchor, setPostControlAnchor] = useState(null);
  const [selectedItem, setSelectedItem] = useState({});
  const [reorderVisible, setReorderVisible] = useState(false);
  const [postStyleVisible, setPostStyleVisible] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [addCaptionItem, setAddCaptionItem] = useState({});
  const [addTextItem, setAddTextItem] = useState();
  const [addGridItem, setAddGridItem] = useState();

  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [importMoodboardVisible, setImportMoodboardVisible] = useState(false);
  const [editGridVisible, setEditGridVisible] = useState(false);
  const [editGrid, setEditGrid] = useState();
  const [settingVisible, setSettingVisible] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [editNameVisible, setEditNameVisible] = useState(false);
  const [editDescriptionVisible, setEditDescriptionVisible] = useState(false);

  const [inputWidth, setInputWidth] = useState(20);
  const [coverImage, setCoverImage] = useState();
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [croppedImage, setCroppedImage] = useState(null);
  const [editCoverVisible, setEditCoverVisible] = useState(false);
  const [scale, setScale] = useState(1);
  const [saveStatus, setSaveStatus] = useState();
  const [gridVariantAnchor, setGridVariantAnchor] = useState(null);
  const [imageEditorVisible, setImageEditorVisible] = useState(false);
  const [tabValue, setTabValue] = useState("post");
  const [randomSeed, setRandomSeed] = useState();

  const uploadRef = useRef(null);
  const captionRef = useRef(null);
  const textRef = useRef(null);
  const boardRef = useRef(null);
  const postNameInputRef = useRef(null);
  const postDescriptionInputRef = useRef(null);
  const uploadVideoRef = useRef(null);

  const uploadCoverRef = useRef(null);
  const [imageRef, setImageRef] = useState(null);
  const parentRef = useRef(null);

  //const { postid } = useParams();
  const navigate = useNavigate();
  let location = useLocation();
  const url = window?.location?.href ? window.location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url) || {};
  let pid = urlObj?.query.pid; //preload data id
  let ptype = urlObj?.query.ptype; //preload data type
  let purl = urlObj?.query.purl;

  const pathnames = window.location.pathname.split("/");
  let postid = null;
  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "edit-post") {
    postid = pathnames[pathnames.length - 1];
  }

  useEffect(() => {
    if (postid) {
      retrievePost(postid);
    } else {
      //reset the data
      setPost(initialData);
      setCroppedImage(null);
    }
  }, [postid]);

  useEffect(() => {
    if (captionRef?.current && addCaptionItem?.id) {
      const editor = captionRef.current.getEditor();
      const quillElement = editor.root;
      quillElement.focus();

      editor.getModule("toolbar").container.addEventListener("mousedown", (e) => {
        e.preventDefault();
      });
    }
  }, [captionRef?.current, addCaptionItem?.id]);

  useEffect(() => {
    if (textRef?.current && addTextItem?.id) {
      const editor = textRef.current.getEditor();
      const quillElement = editor.root;
      quillElement.focus();
      editor.getModule("toolbar").container.addEventListener("mousedown", (e) => {
        e.preventDefault();
      });
    }
  }, [textRef?.current, addTextItem?.id]);

  useEffect(() => {
    if ((pid || purl) && ptype) {
      preloadPostData(pid, ptype, purl);
    }
  }, [location]);

  useEffect(() => {
    //set default cover image using first image in content
    if (
      !post?.id &&
      !post?.metadata?.coverImage?.url &&
      post?.metadata?.content &&
      post.metadata.content.length > 0
    ) {
      handleDefaultCoverImage();
    }
  }, [post]);

  const handleDefaultCoverImage = async () => {
    let images = getAllPostImages(post);

    if (images.length > 0) {
      setEditCoverVisible(true);
      const random = new Date().valueOf();
      const uri = await getBase64ImageFromUrl(images[0]?.url + `?random=${random}`);
      setCoverImage(uri);
    }
  };

  const preloadPostData = async (pid, ptype, purl = null) => {
    if (ptype == "product") {
      //preload a style
      const { data } = await api.products.retrieve(pid);
      const product = data?.product || {};
      const designImages = getStyleImages(product, false, ["imageFiles"]);
      const filteredImages = designImages.filter((f) => f?.type && f.type.includes("image")); //remove pdf style
      handleAddStyle(product, filteredImages);
    } else if (ptype == "moodboard") {
      //preload a moodboard
      const { data } = await api.moodboard.get(pid);
      const moodboard = data?.moodboard || {};
      handleAddMoodboard([moodboard]);
      setPost((prev) => ({ ...prev, title: moodboard?.name || prev.title }));
    } else if (ptype == "image" && purl) {
      await handleAddImage(purl);
    }
  };

  const contentActions = [
    {
      label: "Image",
      key: "image",
      icon: <ImageIcon fontSize="medium" />,
      handleClick: () => {
        uploadRef?.current?.click();
      },
    },
    {
      label: "Video/Audio",
      key: "video",
      icon: <PlayCircleIcon fontSize="medium" />,
      handleClick: () => {
        uploadVideoRef?.current?.click();
      },
    },

    {
      label: "Style",
      key: "style",
      icon: <StyleIcon fontSize="medium" />,
      handleClick: () => {
        setImportStyleVisible(true);
      },
    },
    {
      label: "Moodboard",
      key: "moodboard",
      icon: <PaletteIcon fontSize="medium" />,
      handleClick: () => {
        setImportMoodboardVisible(true);
      },
    },
    {
      label: "Text",
      key: "text",
      icon: <TitleIcon fontSize="medium" />,
      handleClick: () => {
        if (!addTextItem?.id) {
          let newItem = {
            id: nanoid(),
            type: "text",
            mx: DEFAULT_MARGIN_X,
            caption: "",
          };
          setAddTextItem(newItem);
          const newPostData = {
            ...post,
            metadata: {
              ...post.metadata,
              content: [...post.metadata.content, newItem],
            },
          };

          setPost(newPostData);
          window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        } else {
          if (textRef?.current && addTextItem) {
            const editor = textRef.current.getEditor();
            const quillElement = editor.root;
            quillElement.focus();
          }
        }
      },
    },
    {
      label: "Photo Grid",
      key: "grid",
      icon: <ViewComfyIcon fontSize="medium" />,
      handleClick: () => {
        const content = post?.metadata?.content;
        const emptyPhotoGridIndex = content.findIndex(
          (x) => x.type == "grid" && x?.content.length == 0
        );
        if (emptyPhotoGridIndex == -1) {
          let newItem = {
            id: nanoid(),
            type: "grid",
            mx: DEFAULT_MARGIN_X,
            content: [],
            col: 1,
            gap: 0,
            variant: "standard",
            caption: "",
          };
          setAddGridItem(newItem);
          const newPostData = {
            ...post,
            metadata: {
              ...post.metadata,
              content: [...post.metadata.content, newItem],
            },
          };

          setPost(newPostData);

          window.scrollTo({ top: document.body.scrollHeight + 400, behavior: "smooth" });
        }
      },
    },
    {
      label: "Split Columns",
      key: "column",
      icon: <VerticalSplitIcon fontSize="medium" />,
      handleClick: () => {
        const content = post?.metadata?.content;
        const emptyPhotoGridIndex = content.findIndex(
          (x) => x.type == "column" && x?.content.length == 0
        );
        if (emptyPhotoGridIndex == -1) {
          const DEFAULT_COLUMN_GAP = 0;

          let newItem = {
            id: nanoid(),
            type: "column",
            mx: DEFAULT_MARGIN_X,
            content: [
              { id: nanoid(), width: "50%" },
              { id: nanoid(), width: "50%" },
            ],
            gap: DEFAULT_COLUMN_GAP,
            variant: "standard",
            caption: "",
          };

          const newPostData = {
            ...post,
            metadata: {
              ...post.metadata,
              content: [...post.metadata.content, newItem],
            },
          };

          setPost(newPostData);

          window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        }
      },
    },
  ];

  const retrievePost = async (id) => {
    try {
      const { data } = await api.post.retrieve(id);
      setPost(data?.post);
      setCroppedImage(data?.post?.metadata?.coverImage?.url);
    } catch (err) {
      console.log(err);
      toast.error("Failed to retrieve the post!");
    }
  };

  const handleClosePostControlMenu = () => {
    setPostControlAnchor(null);
    setSelectedItem({});
  };

  const PostControlMenu = ({ key }) => (
    <Menu
      id={"post-control-menu-" + key}
      anchorEl={postControlAnchor}
      open={Boolean(postControlAnchor)}
      onClose={handleClosePostControlMenu}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
    >
      <MenuItem
        onClick={() => {
          setReorderVisible(true);
          handleClosePostControlMenu();
        }}
      >
        Reorder Items
      </MenuItem>
      {["moodboard", "style", "image", "grid"].includes(selectedItem.type) ? (
        <MenuItem
          onClick={() => {
            setAddCaptionItem(selectedItem);
            handleClosePostControlMenu();
          }}
        >
          Add Caption
        </MenuItem>
      ) : null}
      {["moodboard", "style", "image"].includes(selectedItem.type) ? (
        <MenuItem onClick={handleReplaceImage}>Replace Image</MenuItem>
      ) : null}
      {["moodboard", "style", "image"].includes(selectedItem.type) ? (
        <MenuItem
          onClick={() => {
            window.open(selectedItem?.img?.url);
            handleClosePostControlMenu();
          }}
        >
          Download Image
        </MenuItem>
      ) : null}
      {["grid"].includes(selectedItem.type) ? (
        <MenuItem
          onClick={() => {
            setEditGridVisible(true);
            setEditGrid(selectedItem);
            handleClosePostControlMenu();
          }}
        >
          Edit Grid
        </MenuItem>
      ) : null}
      <MenuItem onClick={handleDeleteImage}>Remove</MenuItem>
    </Menu>
  );

  const handleReplaceImage = () => {
    uploadRef?.current?.click();
    handleClosePostControlMenu();
  };

  const handleResizeContent = (item, delta, space) => {
    const newContent = [...post?.metadata?.content];
    const contentIndex = newContent.findIndex((x) => x?.id == item.id);
    if (space) {
      newContent[contentIndex].mx = space;
    } else {
      let oldMx = newContent[contentIndex].mx || 0;
      newContent[contentIndex].mx = oldMx + delta < 0 ? 0 : oldMx + delta;
    }

    const newPostData = {
      ...post,
      metadata: {
        ...post.metadata,
        content: newContent,
      },
    };

    setPost(newPostData);
  };

  const handleDeleteImage = () => {
    const newContent = [...post?.metadata?.content];
    const contentIndex = newContent.findIndex((x) => x?.id == selectedItem.id);
    newContent.splice(contentIndex, 1);
    console.log("delete:" + selectedItem.id);
    const newPostData = {
      ...post,
      metadata: {
        ...post.metadata,
        content: newContent,
      },
    };

    setPost(newPostData);
    handleClosePostControlMenu();
  };

  const handleOnFileChange = async (e) => {
    const prefileList = e?.target?.files;
    const fileList = uploadFileSizeLimit(prefileList);
    if (uploadRef?.current) {
      uploadRef.current.value = "";
    }
    if (fileList.length == 0) {
      return;
    }
    setUploading(true);
    try {
      const { data } = await api.uploads.create(fileList, {}, `/post/${nanoid()}`);
      const results = data?.uploads || [];
      const addContents = [];
      for (let i = 0; i < results.length; i++) {
        let mimeType = "image/*";
        for (let j = 0; j < fileList.length; j++) {
          if (fileList[j].name == results[i].name) {
            mimeType = fileList[j].type;
          }
        }
        const dimensions = await getImageSize(results[i].url);

        let content = {
          id: nanoid(),
          type: "image",
          img: {
            url: results[i].url,
            type: mimeType,
            name: results[i].name,
          },
          dimensions: dimensions,
          mx: DEFAULT_MARGIN_X,
          caption: "",
        };
        addContents.push(content);
      }
      const oldContent = post?.metadata?.content || [];
      if (selectedItem?.id && selectedItem?.type == "grid") {
        handleUpdatePhotoGrid(selectedItem, { content: content });
      } else {
        setPost({
          ...post,
          metadata: {
            ...post.metadata,
            content: [...oldContent, ...addContents],
          },
        });
      }

      toast.success("Upload successfully!");
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });

      setUploading(false);
    } catch (err) {
      console.log(err);
      toast.error("Upload failed!");

      setUploading(false);
    }
  };

  const handleOnVideoFileChange = async (e) => {
    const prefileList = e?.target?.files;
    const fileList = uploadFileSizeLimit(prefileList);
    if (uploadVideoRef?.current) {
      uploadVideoRef.current.value = "";
    }
    if (fileList.length == 0) {
      return;
    }
    setUploading(true);
    try {
      const { data } = await api.uploads.create(fileList, {}, `/post/${nanoid()}`);
      const results = data?.uploads || [];
      const addContents = [];
      for (let i = 0; i < results.length; i++) {
        let mimeType = "video/*";
        for (let j = 0; j < fileList.length; j++) {
          if (fileList[j].name == results[i].name) {
            mimeType = fileList[j].type;
          }
        }

        let content = {
          id: nanoid(),
          type: "video",
          video: {
            url: results[i].url,
            type: mimeType,
            name: results[i].name,
          },
          mx: DEFAULT_MARGIN_X,
          caption: "",
        };
        addContents.push(content);
      }
      const oldContent = post?.metadata?.content || [];

      setPost({
        ...post,
        metadata: {
          ...post.metadata,
          content: [...oldContent, ...addContents],
        },
      });

      toast.success("Upload successfully!");
      window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      setUploading(false);
    } catch (err) {
      console.log(err);

      toast.error("Upload failed!");
      setUploading(false);
    }
  };

  const handleAddStyle = async (selectedStyle, selectedImgs) => {
    let styleContent = [];

    for (let i = 0; i < selectedImgs.length; i++) {
      const dimensions = await getImageSize(selectedImgs[i].url);
      styleContent.push({
        id: nanoid(),
        resource_id: selectedStyle.id,
        resource_title: selectedStyle.title,
        resource_owner_id: selectedStyle?.store?.owner_id,
        type: "style",
        img: selectedImgs[i],
        mx: DEFAULT_MARGIN_X,
        dimensions: dimensions,
        caption: "",
      });
    }
    let oldContent = post?.metadata?.content || [];
    if (selectedItem?.id && selectedItem?.type == "grid") {
      handleUpdatePhotoGrid(selectedItem, { content: styleContent });
    } else {
      const newContent = [...oldContent, ...styleContent];
      const newPostData = {
        ...post,
        title: !post?.title || post.title == "Untitled" ? selectedStyle.title : post.title,
        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }

    setImportStyleVisible(false);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const handleAddMoodboard = async (selectedMoodboards) => {
    let moodboardContent = [];
    for (let i = 0; i < selectedMoodboards.length; i++) {
      const dimensions = await getImageSize(selectedMoodboards[i].img.url);

      moodboardContent.push({
        id: nanoid(),
        resource_id: selectedMoodboards[i].id,
        resource_title: selectedMoodboards[i]?.name,
        resource_owner_id: selectedMoodboards[i]?.owner?.id,
        type: "moodboard",
        img: selectedMoodboards[i].img,
        mx: DEFAULT_MARGIN_X,
        dimensions: dimensions,
        caption: "",
      });
    }
    const oldContent = post?.metadata?.content || [];
    if (selectedItem?.id && selectedItem?.type == "grid") {
      handleUpdatePhotoGrid(selectedItem, { content: moodboardContent });
    } else {
      const newContent = [...oldContent, ...moodboardContent];

      const newPostData = {
        ...post,
        title:
          (!post?.title || post.title == "Untitled") && selectedMoodboards.length > 0
            ? selectedMoodboards[0].name
            : post.title,

        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }

    setImportMoodboardVisible(false);
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const handleAddImage = async (url) => {
    try {
      const dimensions = await getImageSize(url);

      const addContents = [];
      let content = {
        id: nanoid(),
        type: "image",
        img: {
          url: url,
          type: "image/*",
          name: url,
        },
        dimensions: dimensions,
        mx: DEFAULT_MARGIN_X,
        caption: "",
      };
      addContents.push(content);

      const oldContent = post?.metadata?.content || [];
      setPost({
        ...post,
        metadata: {
          ...post.metadata,
          content: [...oldContent, ...addContents],
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdatePhotoGrid = (item, payload) => {
    let oldContent = post?.metadata?.content || [];

    if (item?.id && item?.type == "grid") {
      const findIndex = oldContent.findIndex((x) => x?.id == item?.id);

      if (findIndex > -1) {
        let gridContent = oldContent[findIndex]?.content || [];
        const newGridContent = payload?.content || [];
        for (let i = 0; i < newGridContent.length; i++) {
          gridContent.push(newGridContent[i]);
        }

        oldContent[findIndex]["content"] = gridContent;
        oldContent[findIndex]["col"] = payload.hasOwnProperty("col")
          ? payload.col
          : oldContent[findIndex]["col"];
        oldContent[findIndex]["gap"] = payload.hasOwnProperty("gap")
          ? payload.gap
          : oldContent[findIndex]["gap"];

        const newPostData = {
          ...post,
          metadata: {
            ...post?.metadata,
            content: oldContent,
          },
        };

        setPost(newPostData);
      }
    }
  };

  const handleSavePost = async (status, redirect = true) => {
    const statusMessage = status == "published" ? "publish" : "save";
    if (status != "published" && status != "draft") {
      return;
    }

    if (!post?.metadata?.coverImage && status == "published") {
      setSettingVisible(true);
      setSaveStatus(status);
      return;
    }

    const title = post?.title || "Untitled";

    let newPost = { title: title, metadata: post.metadata, status: status };

    //check if there is any unsaved text component
    if (textRef?.current && addTextItem) {
      const textEditor = textRef.current.getEditor();
      const pureText = textEditor.getText();

      let newTextItem = { ...addTextItem };

      if (!pureText.trim()) {
        //when text is empty,set caption to empty.otherwise the default value could be <p><br/></p>
        newTextItem.caption = "";
      }

      //set caption value to post
      const newContent = [...post?.metadata?.content];
      const contentIndex = newContent.findIndex((x) => x?.id == newTextItem?.id);
      if (contentIndex != -1) {
        //do edit
        if (newTextItem.caption == "") {
          newContent.splice(contentIndex, 1);
        } else {
          newContent[contentIndex] = newTextItem;
        }
      } else {
        //do add
        if (newTextItem.caption == "") {
          //remove
        } else {
          if (newTextItem?.id) {
            newContent.push(newTextItem);
          }
        }
      }

      newPost = {
        ...newPost,
        metadata: {
          ...newPost.metadata,
          content: newContent,
        },
      };

      setAddTextItem(undefined);
    }

    try {
      //do update

      if (status == "published") {
        newPost.metadata.published_at = moment();
      }
      if (
        status == "published" &&
        (!post?.metadata?.content || post?.metadata?.content.length == 0)
      ) {
        return toast.error("Please add a content to your post!");
      }

      if (post?.id) {
        await api.post.update(post.id, newPost);
      } else {
        await api.post.create(newPost);
        //create process located in setting modal
      }

      toast.success(`Successfully ${statusMessage} the post!`);
      if (redirect) {
        navigate(`/my-posts?status=${status}`);
      }
    } catch (err) {
      console.log(err);
      toast.error(`Failed to ${statusMessage} the post!`);
    }
  };

  const handleChangePostName = async () => {
    let value = postNameInputRef?.current?.value || "";
    value = value.trim();

    if (value == post?.title || !value) {
      setEditNameVisible(false);
      return;
    } else {
      value = value.slice(0, POST_NAME_MAX_LENGTH);
    }

    setPost((prev) => ({ ...prev, title: value }));

    setEditNameVisible(false);
  };

  const handleChangePostDescription = async () => {
    let value = postDescriptionInputRef?.current?.value || "";
    value = value.trim();

    if (value == post?.metadata?.description) {
      //can be empty string
      setEditDescriptionVisible(false);
      return;
    } else {
      value = value.slice(0, POST_DESCRIPTION_MAX_LENGTH);
    }

    setPost((prev) => ({
      ...prev,
      metadata: {
        ...prev.metadata,
        description: value,
      },
    }));

    setEditDescriptionVisible(false);
  };

  const handleShowEditPostDescription = () => {
    setEditDescriptionVisible(true);
    //setInputWidth(post?.metadata?.description?.length || 20);
  };

  const renderExistedImages = () => {
    const content = post?.metadata?.content || [];
    let images = [];
    if (content.length > 0) {
      images = getAllPostImages(post);
    }

    return (
      <SuiBox
        sx={{
          display: "flex",
          gap: "4px",
          flexWrap: "nowrap",
          overflow: "auto",
          m: 2,
        }}
      >
        {images.map((item) => (
          <SuiBox
            key={item.img}
            style={{
              cursor: "pointer",
              width: 50,
              height: 50,
              minWidth: 50,
              overflow: "hidden",
              borderRadius: "8px",
              objectFit: "cover",
              objectPosition: "center",
            }}
            onClick={async (e) => {
              const random = new Date().valueOf();

              const uri = await getBase64ImageFromUrl(item.url + `?random=${random}`);
              setCoverImage(uri);
            }}
            component="img"
            src={item.url}
            alt={item.name}
          ></SuiBox>
        ))}
      </SuiBox>
    );
  };

  const handleOnCoverFileChange = async (e) => {
    const fileList = e?.target?.files;
    if (fileList.length > 0) {
      try {
        setUploading(true);
        const uri = await getBase64(fileList[0]);
        setCoverImage(uri);
        setUploading(false);
        toast.success("Upload successfully!");
      } catch (err) {
        setUploading(false);
        toast.error("Upload failed!");
      }
    }
  };

  const getCroppedImg = async (image, croppedAreaPixels) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const pixelRatio = window.devicePixelRatio;

    canvas.width = croppedAreaPixels.width * pixelRatio;
    canvas.height = croppedAreaPixels.height * pixelRatio;

    ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    ctx.imageSmoothingQuality = "high";

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    return canvas.toDataURL(CROPPED_IMAGE_TYPE);
  };

  //first parameter is percentage,second is pixels
  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    try {
      const croppedImageBase64 = await getCroppedImg(imageRef.current, croppedAreaPixels);
      setCroppedImage(croppedImageBase64);
    } catch (err) {
      console.log(err);
    }
  };
  const handleSaveCoverImage = async () => {
    let newPost = { ...post };

    if (!croppedImage) {
      return toast.error("A cover image is required for a post!");
    }

    try {
      setUploading(true);
      const fileName = nanoid();
      const imageFile = dataURLtoFile(croppedImage, fileName);
      const { data } = await api.uploads.create([imageFile], {}, "/post");
      if (data?.uploads && data?.uploads.length > 0) {
        if (!newPost?.metadata) {
          newPost["metadata"] = {};
        }
        if (newPost?.metadata) {
          newPost.metadata.coverImage = {
            url: data?.uploads[0].url,
            name: fileName,
            type: CROPPED_IMAGE_TYPE,
          };
        }
        setPost(newPost);
        setUploading(false);
        setEditCoverVisible(false);
      }
    } catch (err) {
      setUploading(false);
      console.log(err);
      return toast.error("Failed to save!");
    }
  };

  const handleShowCoverImageEdit = async () => {
    setEditCoverVisible(true);
  };

  const handleCloseGridVariantMenu = () => setGridVariantAnchor(null);

  const handleResizeImageContent = (e, direction, ref, delta, item) => {
    let oldContent = post?.metadata?.content || [];
    let newContent = [...oldContent];

    for (let i = 0; i < newContent.length; i++) {
      if (newContent[i]?.id == item.id) {
        const childWidth = ref.offsetWidth || 1;
        let parentElemWidth = boardRef?.current?.offsetWidth || childWidth;

        newContent[i]["width"] = ((childWidth * 100) / parentElemWidth).toFixed(2) + "%";
      }

      const newPostData = {
        ...post,
        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }
  };

  const handleChangeAlignment = (item, alignment) => {
    let oldContent = post?.metadata?.content || [];
    let newContent = [...oldContent];

    for (let i = 0; i < newContent.length; i++) {
      if (newContent[i]?.id == item.id) {
        newContent[i]["alignment"] = alignment;
      }

      const newPostData = {
        ...post,
        metadata: {
          ...post?.metadata,
          content: newContent,
        },
      };

      setPost(newPostData);
    }
  };

  const renderPostContent = (item) => {
    if (item?.type == "text") {
      return (
        <SuiBox
          sx={{
            mt: 1,
            position: "relative",
            width: "100%",
          }}
        >
          {addTextItem?.id == item?.id ? (
            <SuiBox mx={8} onBlur={() => "I'm blured!"}>
              <ReactQuill
                placeholder="Enter your text here"
                theme="snow"
                value={addTextItem?.caption || ""}
                onChange={(value) => {
                  setAddTextItem({ ...addTextItem, caption: value });
                }}
                ref={textRef}
                modules={modules}
                onBlur={(previousRange, source, editor) => {
                  if (source != "user") {
                    return;
                  }
                  if (textRef?.current) {
                    const textEditor = textRef.current.getEditor();
                    const pureText = textEditor.getText();

                    let newTextItem = { ...addTextItem };

                    if (!pureText.trim()) {
                      //when text is empty,set caption to empty.otherwise the default value could be <p><br/></p>
                      newTextItem.caption = "";
                    }

                    //set caption value to post
                    const newContent = [...post?.metadata?.content];
                    const contentIndex = newContent.findIndex((x) => x?.id == newTextItem?.id);
                    if (contentIndex != -1) {
                      //do edit
                      if (newTextItem.caption == "") {
                        newContent.splice(contentIndex, 1);
                      } else {
                        newContent[contentIndex] = newTextItem;
                      }
                    } else {
                      //do add
                      if (newTextItem.caption == "") {
                        //remove
                      } else {
                        if (newTextItem?.id) {
                          newContent.push(newTextItem);
                        }
                      }
                    }
                    const newPostData = {
                      ...post,
                      metadata: {
                        ...post.metadata,
                        content: newContent,
                      },
                    };

                    setPost(newPostData);
                    setAddTextItem(undefined);
                  }
                }}
                onFocus={() => {
                  console.log("I'm focused on main text input");
                }}
              />
            </SuiBox>
          ) : (
            <SuiBox
              sx={{ width: item?.width || "100%", minHeight: 20 }}
              onClick={() => {
                setAddTextItem(item);
              }}
            >
              <SuiTypography variant="body1" sx={{ wordBreak: "break-word" }}>
                {parse(item?.caption)}
              </SuiTypography>
            </SuiBox>
          )}
        </SuiBox>
      );
    } else if (item.type == "grid") {
      return (
        <div style={{ height: "100%", width: "100%" }}>
          <SuiBox
            display="flex"
            alignItems="center"
            gap={2}
            sx={{ mb: 2, pt: 1, flexGrow: 1, px: 2, width: "100%" }}
          >
            <SuiButton
              variant="outlined"
              color="dark"
              size="small"
              sx={{
                textTransform: "capitalize",
                borderRadius: 1,
                px: 1,
                fontSize: 12,
                minWidth: 70,
                py: 0,
                whiteSpace: "nowrap",
              }}
              onClick={(e) => {
                setEditGridVisible(true);
                setEditGrid(item);
              }}
            >
              <EditIcon sx={{ width: 14, height: 14 }} />
              Edit
            </SuiButton>
            <SuiBox
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "flex",
                  xl: "flex",
                },
                gap: 2,
                alignItems: "center",
                minWidth: 160,
              }}
            >
              <SuiTypography variant="body1" color="dark" sx={{ minWidth: 24, width: 24 }}>
                Cols
              </SuiTypography>
              <Slider
                valueLabelDisplay="auto"
                min={1}
                max={item?.content?.length || 1}
                value={item?.col || 1}
                marks
                onChange={(e, value) =>
                  item.col != value ? handleUpdatePhotoGrid(item, { col: value }) : null
                }
                sx={{ flexGrow: 1 }}
              />
              <SuiBox>{item?.col || 1}</SuiBox>
            </SuiBox>
            <SuiBox
              sx={{
                display: {
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "flex",
                  xl: "flex",
                },
                gap: 2,
                alignItems: "center",
                width: 180,
                minWidth: 180,
              }}
            >
              <SuiTypography variant="body1" color="dark" sx={{ minWidth: 24, width: 24 }}>
                Gap
              </SuiTypography>
              <Slider
                valueLabelDisplay="auto"
                min={0}
                max={80}
                value={item?.gap || 0}
                onChange={(e, value) => handleUpdatePhotoGrid(item, { gap: value })}
                sx={{ flexGrow: 1 }}
              />
              <SuiBox>{item?.gap || 0}</SuiBox>
            </SuiBox>
          </SuiBox>
          <Resizable
            size={{ width: item?.width || "100%", height: "auto" }}
            onResizeStop={(e, direction, ref, d) =>
              handleResizeImageContent(e, direction, ref, d, item)
            }
            bounds={parentRef.current}
            style={{ border: "#efefef 1px solid" }}
          >
            <PhotoGrid
              setAddGridItem={setAddGridItem}
              addGridItem={addGridItem}
              post={post}
              setPost={setPost}
              gridContent={item}
            />
          </Resizable>
        </div>
      );
    } else if (item.type == "column") {
      return (
        <SuiBox sx={{ width: "100%", height: "auto" }}>
          <EditColumnGrid
            post={post}
            setPost={setPost}
            columnGrid={item}
            selectedItem={selectedItem}
            setSelectedItem={setSelectedItem}
            pending={!!addTextItem}
            parentTextRef={textRef}
          />
        </SuiBox>
      );
    } else if (item.type == "video") {
      return item?.video ? (
        <Resizable
          size={{ width: item?.width || "100%", height: "auto" }}
          onResizeStop={(e, direction, ref, d) =>
            handleResizeImageContent(e, direction, ref, d, item)
          }
          bounds={boardRef.current}
          style={{ border: "#efefef 1px solid" }}
        >
          <ReactPlayer
            controls={true}
            url={item?.video?.url}
            height="100%"
            style={{ minHeight: 50 }}
            width="100%"
            fallback={<Skeleton animation="wave" height={200} width="100%" variant="rectangular" />}
            className="flex justify-center items-center"
          />

          <PostImageWrapper item={item} post={post} setPost={setPost} isEdit={true} />
        </Resizable>
      ) : null;
    } else {
      return item?.img ? (
        <Resizable
          size={{ width: item?.width || "100%", height: "auto" }}
          onResizeStop={(e, direction, ref, d) =>
            handleResizeImageContent(e, direction, ref, d, item)
          }
          bounds={boardRef.current}
          style={{ border: "#efefef 1px solid" }}
        >
          <PostImageWrapper item={item} post={post} setPost={setPost} isEdit={true} />
        </Resizable>
      ) : null;
    }
  };

  const handleAfterEditImage = (item, newImageItem) => {
    const payload = {
      ...item,
      img: {
        name: item?.img?.name || "cropped_img.jpg",
        url: newImageItem?.url,
        type: CROPPED_IMAGE_TYPE,
      },
      dimensions: { width: newImageItem?.width, height: newImageItem?.height },
    };
    const newPost = handleUpdatePostContent(post, payload);
    setPost(newPost);
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
      value: index,
    };
  }

  const handleChangePostFile = async (item) => {
    try {
      if (post?.metadata?.content && post?.metadata?.content.length > 0) {
        await handleSavePost("draft", false);
      }
      window.history.replaceState("", "Post", `/edit-post/${item.id}`);

      setTabValue("post");
    } catch (err) {
      console.log(err);
    }
  };

  const handleRefreshComponent = async () => {
    setRandomSeed(Math.random());
  };

  return (
    <SuiBox mt={2} key={randomSeed}>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <NewSharedBar
        type="post"
        data={post}
        title={
          <SuiBox display="flex" justifyContent="center" alignItems="center">
            {editNameVisible ? (
              <div className="flex">
                <input
                  defaultValue={post?.title}
                  ref={postNameInputRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleChangePostName();
                    }
                  }}
                  className="font-serif"
                  autoFocus
                  style={{
                    outline: "none",
                    border: "none",
                    width: inputWidth + "ch",
                    fontSize: "1.25rem",
                    lineHeight: 1.375,
                    fontWeight: 700,
                  }}
                  onChange={(e) => setInputWidth(e.target?.value?.length + 1)}
                  onBlur={handleChangePostName}
                />
              </div>
            ) : (
              <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
                <Tooltip title={"Click to modify the name."}>
                  <SuiTypography
                    variant="h5"
                    className="font-serif"
                    fontWeight="bold"
                    textTransform="none"
                    onClick={() => {
                      setEditNameVisible(true);
                      setInputWidth(post?.title?.length + 1);
                    }}
                  >
                    {post?.title}
                  </SuiTypography>
                </Tooltip>
              </SuiBox>
            )}
          </SuiBox>
        }
        handleRefreshSourceData={retrievePost}
        extraAction={null}
      />

      <SuiBox display="flex" position="relative">
        <SuiBox
          sx={{
            position: "sticky",
            top: 20,
            minWidth: { lg: 240, md: 240, sm: 170, xs: 170 },
            width: { lg: 240, md: 240, sm: 170, xs: 170 },
          }}
        >
          <SuiBox mr={0.5}>
            <Tabs
              value={tabValue}
              onChange={(e, v) => setTabValue(v)}
              aria-label="icon position tabs example"
              sx={{ mb: 0.5 }}
            >
              <Tab
                icon={<DesktopWindowsOutlinedIcon fontSize="small" />}
                iconPosition="start"
                label={
                  <SuiTypography
                    sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                  >
                    Tools
                  </SuiTypography>
                }
                sx={{ fontSize: 14 }}
                {...a11yProps("post")}
              />
              <Tab
                icon={<FolderIcon fontSize="small" />}
                iconPosition="start"
                label={
                  <SuiTypography
                    sx={{ display: { xs: "none", sm: "none", md: "block", lg: "block" } }}
                  >
                    Folder
                  </SuiTypography>
                }
                sx={{ fontSize: 14 }}
                {...a11yProps("folder")}
              />
            </Tabs>
            <TabPanel value={tabValue} index={"post"}>
              <Card sx={{ borderRadius: 1, mb: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
                <SuiBox sx={{ width: "100%", lineHeight: 2.4, backgroundColor: "#f3f3f3", px: 1 }}>
                  Add Content
                </SuiBox>
                <Grid container>
                  {contentActions.map((item, index) => (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={6}
                      key={index}
                      onClick={() => {
                        item.handleClick();
                      }}
                    >
                      <SuiBox
                        sx={{
                          border: "1px solid #efefef",
                          p: 1,
                          textAlign: "center",
                          margin: "auto",
                          lineHeight: 1.2,
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "#f3f3f3",
                          },
                        }}
                      >
                        {item.icon}
                        <div>{item.label}</div>
                      </SuiBox>
                    </Grid>
                  ))}
                </Grid>
                <SuiBox sx={{ width: "100%", lineHeight: 2.4, backgroundColor: "#f3f3f3", px: 1 }}>
                  Setting
                </SuiBox>
                <Grid container>
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <SuiBox
                      sx={{
                        border: "1px solid #efefef",
                        p: 1,
                        textAlign: "center",
                        margin: "auto",
                        lineHeight: 1.2,
                        cursor: "pointer",
                        "&:hover": {
                          backgroundColor: "#f3f3f3",
                        },
                      }}
                      onClick={() => setPostStyleVisible(true)}
                    >
                      <FitScreenIcon fontSize="medium" />
                      <div>Layout</div>
                    </SuiBox>
                  </Grid>
                </Grid>
              </Card>
            </TabPanel>
            <TabPanel value={tabValue} index={"folder"}>
              <PostFileList
                currentItemId={post?.id}
                handleClick={handleChangePostFile}
                handleRefresh={handleRefreshComponent}
              />
            </TabPanel>
          </SuiBox>
        </SuiBox>

        <SuiBox sx={{ flex: "1 1 auto", px: 2, minHeight: "60vh" }}>
          <SuiBox
            sx={{
              border: "1px solid #efefef",
              borderRadius: 1,
              boxShadow: "4px",
              backgroundColor: post?.metadata?.settings?.backgroundColor,
              boxShadow: ({ boxShadows: { md } }) => md,
            }}
          >
            {post?.metadata?.content && post.metadata.content.length > 0 ? (
              <SuiBox>
                {post?.metadata?.content.map((item, index) => (
                  <SuiBox
                    key={index}
                    sx={{
                      marginBottom: post?.metadata?.settings?.mb + "px",
                    }}
                  >
                    <SuiBox
                      sx={{
                        mx: item?.mx + "px",
                        mt: item?.mx && index == 0 ? item?.mx + "px" : 0,
                        mb:
                          item?.mx && index == post.metadata.content.length - 1
                            ? item?.mx + "px"
                            : 0,

                        position: "relative",
                        height: "100%",
                      }}
                      className={`new-post-item ${
                        selectedItem?.id == item?.id ? "edit-item-menu" : ""
                      }`}
                      ref={parentRef}
                    >
                      <div
                        ref={boardRef}
                        style={{
                          height: "100%",
                          width: "100%",
                          display: "flex",
                          justifyContent: item?.alignment || "center",
                        }}
                      >
                        {renderPostContent(item)}

                        <SuiBox
                          sx={{
                            position: "absolute",
                            left: -10,
                            top: -20,
                          }}
                          className="post-item-control"
                        >
                          <IconButton
                            size="small"
                            color="dark"
                            sx={{
                              background: "50%",
                              backgroundColor: colors?.info.main,

                              "&:hover": {
                                backgroundColor: colors?.info.main,
                              },
                            }}
                            onClick={(e) => {
                              setSelectedItem(item);
                              setPostControlAnchor(e.target);
                            }}
                          >
                            <EditIcon fontSize="medium" color="white" />
                          </IconButton>
                          <PostControlMenu item={item} key={index} />
                        </SuiBox>
                        <SuiBox
                          sx={{
                            position: "absolute",
                            right: 10,
                            top: -20,
                          }}
                          className="post-item-control"
                        >
                          {item?.mx == 0 ? (
                            <SuiButton
                              color={"secondary"}
                              circular
                              size="small"
                              sx={{ p: 0 }}
                              onClick={() => handleResizeContent(item, DEFAULT_MARGIN_X)}
                            >
                              {" "}
                              <ArrowForwardIcon sx={{ width: 20, height: 20 }} fontSize="medium" />
                              <ArrowBackIcon sx={{ width: 20, height: 20 }} fontSize="medium" />
                            </SuiButton>
                          ) : (
                            <SuiButton
                              color={"secondary"}
                              circular
                              size="small"
                              sx={{ p: 0 }}
                              onClick={() => handleResizeContent(item, -30)}
                            >
                              <ArrowBackIcon sx={{ width: 20, height: 20 }} fontSize="medium" />
                              <ArrowForwardIcon sx={{ width: 20, height: 20 }} fontSize="medium" />
                            </SuiButton>
                          )}
                        </SuiBox>

                        {item?.type != "text" && item?.type != "column" ? (
                          <SuiBox
                            sx={{
                              position: "absolute",
                              right: "42%",
                              top: -20,
                            }}
                            className="post-item-control"
                          >
                            <SuiBox display="flex" alignItems="center">
                              <ButtonGroup>
                                <SuiButton
                                  color={"white"}
                                  size="medium"
                                  sx={{ p: 0, minWidth: 26, minHeight: 28, borderRadius: 0 }}
                                  onClick={() => handleChangeAlignment(item, "flex-start")}
                                >
                                  <FormatAlignLeftIcon sx={{ width: 24, height: 24 }} />{" "}
                                </SuiButton>
                                <SuiButton
                                  color={"white"}
                                  size="medium"
                                  sx={{ p: 0, minWidth: 26, minHeight: 28, borderRadius: 0 }}
                                  onClick={() => handleChangeAlignment(item, "center")}
                                >
                                  <FormatAlignCenterIcon sx={{ width: 24, height: 24 }} />
                                </SuiButton>
                                <SuiButton
                                  color={"white"}
                                  size="medium"
                                  sx={{ p: 0, minWidth: 26, minHeight: 28, borderRadius: 0 }}
                                  onClick={() => handleChangeAlignment(item, "flex-end")}
                                >
                                  <FormatAlignRightIcon sx={{ width: 24, height: 24 }} />
                                </SuiButton>
                              </ButtonGroup>
                            </SuiBox>
                          </SuiBox>
                        ) : null}
                      </div>
                    </SuiBox>
                    {/*Image Caption*/}
                    {(item?.caption != "" || addCaptionItem?.id == item.id) &&
                    item.type != "text" ? (
                      <SuiBox
                        sx={{
                          mx: item?.mx + "px",
                          mt: 2,
                          position: "relative",
                        }}
                        className={`new-post-item ${
                          selectedItem?.id == item.id ? "edit-item-menu" : ""
                        }`}
                      >
                        {addCaptionItem?.id == item.id ? (
                          <ReactQuill
                            placeholder="Enter your caption here"
                            theme="snow"
                            value={addCaptionItem?.caption || ""}
                            onChange={(value) => {
                              setAddCaptionItem({ ...addCaptionItem, caption: value });
                            }}
                            modules={modules}
                            ref={captionRef}
                            onBlur={(previousRange, source, editor) => {
                              if (source != "user") {
                                return;
                              }
                              if (captionRef?.current) {
                                const textEditor = captionRef.current.getEditor();
                                const pureText = textEditor.getText();
                                let newCaptionItem = { ...addCaptionItem };

                                if (!pureText.trim()) {
                                  //when text is empty,set caption to empty.otherwise the default value could be <p><br/></p>
                                  newCaptionItem.caption = "";
                                }

                                //set caption value to post
                                const newContent = [...post?.metadata?.content];
                                const contentIndex = newContent.findIndex(
                                  (x) => x?.id == newCaptionItem.id
                                );
                                newContent[contentIndex] = newCaptionItem;
                                const newPostData = {
                                  ...post,
                                  metadata: {
                                    ...post.metadata,
                                    content: newContent,
                                  },
                                };

                                setPost(newPostData);
                                setAddCaptionItem(null);
                              }
                            }}
                            onFocus={() => {
                              console.log("I'm focused");
                            }}
                          />
                        ) : (
                          <SuiTypography
                            variant="body1"
                            onClick={() => {
                              setAddCaptionItem(item);
                            }}
                          >
                            {parse(item?.caption)}
                          </SuiTypography>
                        )}
                      </SuiBox>
                    ) : null}
                  </SuiBox>
                ))}
              </SuiBox>
            ) : (
              <SuiBox sx={{ width: "100%", height: "60vh" }}>
                {/* <SuiBox
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <SuiTypography variant="h6" color="text" sx={{ my: 1 }}>
                    Start creating your post:
                  </SuiTypography>
                  <SuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    flexWrap="wrap"
                    gap={3}
                  >
                    {contentActions.map((item, index) => (
                      <SuiBox
                        key={index}
                        sx={{ textAlign: "center" }}
                        onClick={() => {
                          item.handleClick();
                        }}
                      >
                        <IconButton
                          size="large"
                          color="dark"
                          sx={{
                            background: "50%",
                            backgroundColor: colors?.lightBlue.main,
                            border: `solid 1px ${colors?.lightBlue.main}`,
                          }}
                        >
                          {item.icon}
                        </IconButton>
                        <SuiTypography variant="body2" color="text" sx={{ mt: 1 }}>
                          {item.label}
                        </SuiTypography>
                      </SuiBox>
                    ))}
                  </SuiBox>
                </SuiBox> */}
              </SuiBox>
            )}
          </SuiBox>
        </SuiBox>

        <SuiBox
          sx={{
            position: "sticky",
            top: 20,
            minWidth: { lg: 280, md: 140, sm: 140, xs: 140 },
            width: { lg: 280, md: 140, sm: 140, xs: 140 },
          }}
        >
          <SuiBox>
            <Card sx={{ borderRadius: 1, mb: 2, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 2.4, backgroundColor: "#f3f3f3", px: 1 }}
              >
                Caption ({post?.metadata?.description?.length || 0}/{POST_DESCRIPTION_MAX_LENGTH})
              </SuiTypography>

              <SuiBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{ height: "100%", width: "100%", py: 1 }}
              >
                {editDescriptionVisible ? (
                  <textarea
                    size="small"
                    defaultValue={post?.metadata?.description}
                    ref={postDescriptionInputRef}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleChangePostDescription();
                      }
                    }}
                    autoFocus
                    style={{
                      width: "100%",
                    }}
                    //onChange={(e) => setInputWidth(e.target?.value?.length)}
                    onBlur={handleChangePostDescription}
                    rows={2}
                  />
                ) : (
                  <SuiBox
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap={1}
                    sx={{ width: "100%", minHeight: 42 }}
                    onClick={() => handleShowEditPostDescription()}
                  >
                    <Tooltip title={"Click to change caption"}>
                      <SuiTypography
                        variant="body1"
                        textTransform="none"
                        sx={{ lineHeight: 1.2, wordBreak: "break-word" }}
                      >
                        {post?.metadata?.description || "Click to add caption"}
                      </SuiTypography>
                    </Tooltip>
                  </SuiBox>
                )}
              </SuiBox>
              <SuiTypography
                variant="body1"
                sx={{ lineHeight: 2.4, backgroundColor: "#f3f3f3", px: 1 }}
                required
              >
                Cover Image
              </SuiTypography>
              <SuiBox>
                <SuiBox>
                  {editCoverVisible ? (
                    <SuiBox>
                      <SuiBox>
                        {coverImage ? (
                          <div>
                            <div
                              style={{
                                width: "100%",
                                height: 234,
                                position: "relative",
                              }}
                            >
                              <Cropper
                                image={coverImage}
                                crop={crop}
                                zoom={scale}
                                aspect={ASPECT_RATIO}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setScale}
                                maxZoom={5}
                                minZoom={1}
                                setImageRef={(ref) => setImageRef(ref)}
                              />
                            </div>
                            <SuiBox sx={{ maxWidth: 200, mx: "auto" }}>
                              <SuiBox
                                gap={1}
                                display="flex"
                                sx={{ mb: 1 }}
                                alignItems="center"
                                justifyContent={"center"}
                              >
                                <ZoomOutIcon fontSize="medium" color={"text"} />
                                <Slider
                                  aria-label="Volume"
                                  value={scale}
                                  onChange={(e, value) => setScale(value)}
                                  max={5}
                                  min={1}
                                  step={0.1}
                                />
                                <ZoomInIcon fontSize="medium" color={"text"} />
                              </SuiBox>
                            </SuiBox>
                            <SuiTypography
                              variant="body1"
                              color="info"
                              sx={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 0.5,
                              }}
                              onClick={() => uploadCoverRef?.current?.click()}
                            >
                              <UploadIcon /> Upload Image
                            </SuiTypography>
                          </div>
                        ) : (
                          <SuiBox
                            sx={{
                              width: "100%",
                              height: 234,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <SuiButton
                              variant="contained"
                              color="info"
                              circular
                              size="small"
                              onClick={() => uploadCoverRef?.current?.click()}
                            >
                              Upload Image
                            </SuiButton>
                            <SuiTypography color="text" variant="body2" sx={{ mt: 1 }}>
                              Upload your cover image
                            </SuiTypography>
                          </SuiBox>
                        )}
                      </SuiBox>
                      <SuiBox sx={{ flexGrow: 1, width: "100%", mt: 2 }}>
                        {renderExistedImages()}
                      </SuiBox>
                      <SuiBox sx={{ width: "100%", textAlign: "center", my: 1 }}>
                        <SuiButton
                          variant="text"
                          color="dark"
                          onClick={() => setEditCoverVisible(false)}
                        >
                          <CloseIcon color="error" />
                          Cancel
                        </SuiButton>
                        <SuiButton
                          variant="text"
                          color="dark"
                          onClick={() => handleSaveCoverImage()}
                          disabled={croppedImage ? false : true}
                        >
                          <CheckIcon color="success" />
                          Save Image
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  ) : croppedImage ? (
                    <SuiBox>
                      <img
                        src={croppedImage}
                        alt="Cropped Image"
                        style={{
                          width: "100%",
                          height: "auto",
                          boxShadow: "0 0 24px rgba(0, 0, 0, 0.3)",
                        }}
                      />
                      <SuiBox sx={{ my: 1, textAlign: "center", width: "100%" }}>
                        <SuiButton variant="text" color="dark" onClick={handleShowCoverImageEdit}>
                          <EditIcon color="info" />
                          Edit Cover Image
                        </SuiButton>
                      </SuiBox>
                    </SuiBox>
                  ) : (
                    <SuiBox sx={{ width: "100%" }}>
                      <SuiBox
                        sx={{
                          width: "100%",
                          height: 234,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                        }}
                      >
                        <SuiTypography
                          variant="h6"
                          color="text"
                          sx={{
                            cursor: "pointer",
                            textDecoration: "underline",
                            mx: 1,
                          }}
                          onClick={handleShowCoverImageEdit}
                        >
                          Upload or choose a cover image
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                  )}
                </SuiBox>
              </SuiBox>
            </Card>
            <Card sx={{ borderRadius: 1, boxShadow: ({ boxShadows: { md } }) => md }}>
              <SuiBox sx={{ m: 2 }}>
                <SuiButton
                  variant="gradient"
                  color={post?.status == "published" ? "secondary" : "success"}
                  circular
                  size="small"
                  sx={{ width: "100%", my: 1 }}
                  onClick={() =>
                    post?.status == "published"
                      ? handleSavePost("draft")
                      : handleSavePost("published")
                  }
                  disabled={
                    !(post?.metadata?.content && post?.metadata?.content.length > 0) ||
                    editCoverVisible
                  }
                >
                  {post?.status == "published" ? "UnPublished" : "Publish"}
                </SuiButton>
                <SuiButton
                  variant="gradient"
                  color="info"
                  circular
                  size="small"
                  sx={{ width: "100%", mb: 1 }}
                  onClick={() =>
                    handleSavePost(post?.status == "published" ? "published" : "draft")
                  }
                  disabled={
                    !(post?.metadata?.content && post?.metadata?.content.length > 0) ||
                    editCoverVisible
                  }
                >
                  Save
                  {post?.status != "published" ? (
                    <SuiBox
                      color="inherit"
                      component={"span"}
                      sx={{ display: { xs: "none", sm: "none", md: "none", lg: "inline" } }}
                    >
                      &nbsp; as Draft
                    </SuiBox>
                  ) : null}
                </SuiButton>

                <SuiButton
                  variant="text"
                  color="secondary"
                  circular
                  size="small"
                  sx={{ width: "100%" }}
                  onClick={() => setPreviewVisible(true)}
                  disabled={
                    !(post?.metadata?.content && post?.metadata?.content.length > 0) ||
                    editCoverVisible
                  }
                >
                  Preview
                </SuiButton>
              </SuiBox>
            </Card>
          </SuiBox>
        </SuiBox>

        <input
          type="file"
          id="imgupload"
          style={{ display: "none" }}
          ref={uploadRef}
          accept="image/*"
          onChange={handleOnFileChange}
          multiple={true}
        />
      </SuiBox>
      <PostStyleModal
        visible={postStyleVisible}
        handleClose={() => setPostStyleVisible(false)}
        post={post}
        setPost={setPost}
      />
      {reorderVisible ? (
        <PostReorderModal
          visible={reorderVisible}
          handleClose={() => setReorderVisible(false)}
          post={post}
          setPost={setPost}
        />
      ) : null}
      {importStyleVisible ? (
        <ImportStylePicturesModal
          handleClose={() => setImportStyleVisible(false)}
          visible={importStyleVisible}
          handleOk={handleAddStyle}
          isMulti={true}
        />
      ) : null}
      {importMoodboardVisible ? (
        <ImportMoodboardPicture
          handleClose={() => setImportMoodboardVisible(false)}
          visible={importMoodboardVisible}
          handleOk={handleAddMoodboard}
          selectedMoodboards={[]}
          isMulti={true}
        />
      ) : null}
      {editGridVisible ? (
        <EditPhotoGrid
          visible={editGridVisible}
          handleClose={() => setEditGridVisible(false)}
          post={post}
          setPost={setPost}
          gridContent={editGrid}
        />
      ) : null}
      {settingVisible && saveStatus ? (
        <SettingModal
          handleClose={() => setSettingVisible(false)}
          visible={settingVisible}
          post={post}
          setPost={setPost}
          edit={edit}
          status={saveStatus}
        />
      ) : null}
      {previewVisible ? (
        <PostDetailModal
          handleClose={() => setPreviewVisible(false)}
          visible={previewVisible}
          post={post}
          setPost={setPost}
          previewMode
        />
      ) : null}
      {imageEditorVisible && selectedItem ? (
        <ImageEditorModal
          handleClose={() => setImageEditorVisible(false)}
          visible={imageEditorVisible}
          selectedItem={selectedItem}
          handleAfterSave={handleAfterEditImage}
        />
      ) : null}
      <input
        type="file"
        id="imgcoverupload"
        style={{ display: "none" }}
        ref={uploadCoverRef}
        accept="image/*"
        onChange={handleOnCoverFileChange}
      />
      <input
        type="file"
        id="videoupload"
        style={{ display: "none" }}
        ref={uploadVideoRef}
        accept="video/*,audio/*"
        onChange={handleOnVideoFileChange}
      />
    </SuiBox>
  );
};

export default CreatePostPage;
